import {
  exists,
  ReserveSetBibliography,
  ReserveSetBibliographyFromJSON
} from '@/api'

export interface ReserveSet {
  id: number
  name: string
  nameKana: string
  revision: number
  bibliographies: ReserveSetBibliography[]
}

export function ReserveSetFromJSON(json: any): ReserveSet {
  return {
    id: exists(json, 'id') ? json.id : 0,
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    revision: exists(json, 'revision') ? json.revision : 0,
    bibliographies: exists(json, 'bibliographies')
      ? json.bibliographies.map(ReserveSetBibliographyFromJSON)
      : []
  }
}
